import { call, put, takeEvery } from 'redux-saga/effects';
import { GetOrderReportApi } from '../../utils/api';
import { handleApiResponse } from '../../utils/functions';
import { GET_ORDER_REPORT_LIST } from '../storeTypes';
import { ActionGetOrderReportListSuccess } from '../Actions/OrderReportAction';

const File = 'OrderReportSaga';

function* GetOrderReportListSaga(action) {
  try {
    const response = yield call(GetOrderReportApi, action.payload);
    if (response?.status === 200) {
      const data = response?.data?.data?.[0];
      yield put(ActionGetOrderReportListSuccess(data));

      // Call the callback if provided
      if (action?.callback) {
        action.callback({
          success: true,
          data: data?.docs || [],
          total: data?.totalDocs || 0,
          page: data?.page || 1,
          perPage: data?.limit || 10,
          totalPages: data?.totalPages || 1,
          hasNextPage: data?.hasNextPage || false,
          hasPrevPage: data?.hasPrevPage || false,
        });
      }
    } else {
      // Handle non-200 responses
      if (action?.callback) {
        action.callback({
          success: false,
          error: 'Failed to fetch order reports',
        });
      }
    }
  } catch (error) {
    handleApiResponse(error?.response?.status, error?.response?.data, action?.callback);
// Call the callback with error if provided
    if (action?.callback) {
      action.callback({
        success: false,
        error: error?.message || 'Failed to fetch order reports',
      });
    }
  }
}

export function* OrderReportSaga() {
  yield takeEvery(GET_ORDER_REPORT_LIST, GetOrderReportListSaga);
}
